export var AICopilotSubjects;
(function (AICopilotSubjects) {
    AICopilotSubjects["OpenDrawerButton"] = "open-chat-drawer-button";
})(AICopilotSubjects || (AICopilotSubjects = {}));
// Values are PERSISTED on `oiq_agents_history` / `ai_conversation_model`; rows written before a member was
// removed are read through Prisma's own wider `DataSource` enum, not this one.
export var AIDataSource;
(function (AIDataSource) {
    AIDataSource["AllAvailableData"] = "AllAvailableData";
    AIDataSource["RCA"] = "RCA";
    AIDataSource["MetricsDashboard"] = "MetricsDashboard";
    AIDataSource["UnifiedDashboard"] = "UnifiedDashboard";
})(AIDataSource || (AIDataSource = {}));
/**
 * Built-in agent types — those with coded behavior (seeding, capping, Bedrock routing, UI).
 * Declared as a const object (not an `enum`) so the same-named `OiqAgentType` *type* below can
 * be widened with `(string & {})`: it accepts arbitrary marketplace template types as plain
 * strings while preserving autocomplete for the built-in values. The full known set
 * (built-in ∪ marketplace) is resolved at runtime — see orioniq-be `agentTypesService.getKnownAgentTypes()`.
 * Note: some built-in values (e.g. RCA, AlertAIAnalysis) also ship as marketplace
 * templates; the runtime resolver dedupes the overlap.
 */
/* eslint-disable @typescript-eslint/naming-convention -- agent type identifiers are PascalCase by product convention (formerly an enum) */
export const OiqAgentType = {
    General: 'General',
    GeneralAI: 'GeneralAI',
    RCA: 'RCA',
    MetricsDashboard: 'MetricsDashboard',
    UnifiedDashboard: 'UnifiedDashboard',
    Custom1: 'Custom1',
    Custom2: 'Custom2',
    Basic: 'Basic',
    AlertAIAnalysis: 'AlertAIAnalysis',
    AlertAIAnalysisv2: 'AlertAIAnalysisv2',
    AlertsFatigue: 'AlertsFatigue',
    PostChangeValidator: 'PostChangeValidator',
    MetricsDistributionMonitor: 'MetricsDistributionMonitor',
    ScheduledErrorMetricsReport: 'ScheduledErrorMetricsReport',
    AgentBuilder: 'AgentBuilder',
    FeedbackReflection: 'FeedbackReflection',
};
export var OiqAgentTriggerType;
(function (OiqAgentTriggerType) {
    OiqAgentTriggerType["Deployment"] = "Deployment";
    OiqAgentTriggerType["Alert"] = "Alert";
    OiqAgentTriggerType["Api"] = "Api";
    OiqAgentTriggerType["Scheduled"] = "Scheduled";
})(OiqAgentTriggerType || (OiqAgentTriggerType = {}));
export var OiqAgentKind;
(function (OiqAgentKind) {
    OiqAgentKind["Log"] = "log_agent";
    OiqAgentKind["Metric"] = "metric_agent";
    OiqAgentKind["LogsMetricsDeep"] = "logs_metrics_deepagent";
    OiqAgentKind["Integration"] = "integration_agent";
})(OiqAgentKind || (OiqAgentKind = {}));
export const OIQ_RCA_TEMPLATE_ID = 'auto-rca';
//# sourceMappingURL=ai-copilot.enum.js.map